<template>

    <nav id="sidebar">
        <div class="menu-top">
            <a class="navbar-brand" href="">

                <img src="images/logo-light.png" alt="">
            </a>
            <div class="menu-title"><span data-key="t-menu">Menu</span></div>
        </div>
        <ul class="list-unstyled components">
            <li :class="[currentRouteName == 'dashboard' ? 'active': '']">
                <router-link :to="{ name: 'dashboard'}"><i class="ri-dashboard-2-line"></i> <span>Dashboard</span>
                </router-link>
            </li>

            <template v-if="currentRouteName == 'quotations'">
                <li @click="forceRefresh('quotations')" :class="[currentRouteName == 'quotations' ||
                currentRouteName == 'addQuotePage' ||
                currentRouteName == 'PriceCalculationPage' ||
                currentRouteName == 'SendToCustomerPage' ||
                currentRouteName == 'ViewCustomerQuote' ||
                currentRouteName == 'draft' ||
                currentRouteName == 'viewQuote'? 'active': '']">
                    <router-link :to="{ name: 'quotations'}">
                        <i class="ri-line-chart-line"></i> Quotations
                    </router-link>
                </li>
            </template>
            <template v-else>
                <li :class="[currentRouteName == 'quotations' ||
                currentRouteName == 'addQuotePage' ||
                currentRouteName == 'PriceCalculationPage' ||
                currentRouteName == 'SendToCustomerPage' ||
                currentRouteName == 'ViewCustomerQuote' ||
                currentRouteName == 'draft' ||
                currentRouteName == 'viewQuote'? 'active': '']">
                    <router-link :to="{ name: 'quotations'}">
                        <i class="ri-line-chart-line"></i> Quotations
                    </router-link>
                </li>
            </template>


            <!--<li>
                <a href="#quotationsSubmenu" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle"><i class="ri-line-chart-line"></i> <span>Quotations</span></a>
                <ul class="collapse list-unstyled" id="quotationsSubmenu">
                    <li>
                        <a href="#">Home 1</a>
                    </li>
                    <li>
                        <a href="#">Home 2</a>
                    </li>
                    <li>
                        <a href="#">Home 3</a>
                    </li>
                </ul>
            </li>-->

            <li>
                <a href="#ordersSubmenu" data-toggle="collapse"
                   :aria-expanded="currentRouteName == 'orders' || currentRouteName == 'draft.orders' || currentRouteName == 'orderShow' ||
                   currentRouteName == 'selectCustomer' || currentRouteName == 'selectQuotes' ||currentRouteName == 'selectProducts' ||currentRouteName == 'provideOtherInfo'"
                   class="dropdown-toggle"><i class="ri-dashboard-2-line"></i> <span>Orders</span></a>
                <ul class="collapse list-unstyled" id="ordersSubmenu"
                    :class="{show: currentRouteName == 'orders' || currentRouteName == 'draft.orders' || currentRouteName == 'orderShow' ||
                   currentRouteName == 'selectCustomer' || currentRouteName == 'selectQuotes' ||currentRouteName == 'selectProducts' ||currentRouteName == 'provideOtherInfo'}">
                    <li>
                       <!-- <router-link :to="{ name: 'orders'}"> All</router-link>-->
                        <a href="javascript:void(0)" @click="goToOrderList(null)">
                             All
                        </a>
                    </li>
                    <template v-for="(role, index) in salesOrderMenuItems">
                        <li  v-if="index != 'total' &&  (index != 'notes')">
                            <a href="javascript:void(0)" @click="goToOrderList(role.status.id)">
                                 {{index}} ({{role.so_count ? role.so_count : 0 }} )
                            </a>
                            <!--<router-link :to="{ name: 'orders',query: { status: role.status.id }}"> {{index}} ({{role.salesOrders ? role.salesOrders.total : 0 }} )</router-link>-->
                        </li>
                    </template>

                    <li>
                        <router-link :to="{ name: 'draft.orders'}"> Drafts
                        </router-link>
                    </li>
                    <li v-if="(authUser!= null && authUser.user_type == 1) || hasRole('Admin') || hasPerm('add-sales-order')">
                        <a href="javascript:void(0)" @click="goToCreateSO">
                             New Order
                        </a>
                        <!--<router-link :to="{ name: 'selectCustomer'}"> New Order
                        </router-link>-->
                    </li>
                </ul>
            </li>
            <li>
                <a href="#purchaseOrdersSubmenu" data-toggle="collapse"
                   :aria-expanded="currentRouteName == 'purchaseOrders' || currentRouteName == 'draft.purchaseOrders' || currentRouteName == 'purchaseOrderShow' ||
                   currentRouteName == 'purchaseSelectProducts' || currentRouteName == 'purchaseSelectVendor' ||currentRouteName == 'purchaseProvideOtherInfo'"
                   class="dropdown-toggle"><i class="ri-shopping-cart-line"></i> <span>Purchase Orders</span></a>
                <ul class="collapse list-unstyled" id="purchaseOrdersSubmenu"
                    :class="{show: currentRouteName == 'purchaseOrders' || currentRouteName == 'draft.purchaseOrders' || currentRouteName == 'purchaseOrderShow' ||
                   currentRouteName == 'purchaseSelectProducts' || currentRouteName == 'purchaseSelectVendor' ||currentRouteName == 'purchaseProvideOtherInfo'}"
                >
                    <li>
                        <!--<router-link :to="{ name: 'purchaseOrders'}"> All
                        </router-link>-->
                        <a href="javascript:void(0)" @click="goToPurchaseOrderList(null)">
                             All
                        </a>
                    </li>
                    <template v-for="(role, index) in purchaseOrderMenuItems">
                        <li  v-if="index != 'total' &&  (index != 'notes')">
                            <a href="javascript:void(0)" @click="goToPurchaseOrderList(role.status.id)">
                                 {{index}} ({{role.po_count ? role.po_count : 0 }} )
                            </a>
                            <!--<router-link :to="{ name: 'purchaseOrders',query: { status: role.status.id }}"> {{index}} ({{role.purchaseOrders ? role.purchaseOrders.total : 0 }} )</router-link>-->
                        </li>
                    </template>
                    <li>
                        <router-link :to="{ name: 'draft.purchaseOrders'}"> Drafts
                        </router-link>
                    </li>
                    <!--<li>
                        <router-link  :to="{ name: 'purchaseSelectCustomer'}"> New Purchase Order</router-link>
                    </li>-->
                </ul>
            </li>
            <li :class="[currentRouteName == 'shipments'  ? 'active': '']">
                <router-link :to="{ name: 'shipments'}"><i class="ri-shopping-basket-2-line"></i> Shipments</router-link>
            </li>
            <li :class="[currentRouteName == 'viewProducts' || currentRouteName == 'productsDetails' || currentRouteName == 'addProducts' || currentRouteName == 'editProducts' ? 'active': '']">
                <router-link :to="{ name: 'viewProducts'}"><i class="ri-shopping-basket-2-line"></i> Products</router-link>
            </li>
            <li @click="forceRefresh('viewVendors')" :class="[currentRouteName == 'viewVendors' || currentRouteName == 'vendorDetails' || currentRouteName == 'addVendor' || currentRouteName == 'editVendor' ? 'active': '']">
                <router-link :to="{ name: 'viewVendors'}"><i class="ri-store-2-line"></i> Vendor</router-link>
            </li>
            <li :class="[currentRouteName == 'viewCustomers' || currentRouteName == 'customerDetails' || currentRouteName == 'addCustomer' || currentRouteName == 'editCustomer' ? 'active': '']">
                <router-link :to="{ name: 'viewCustomers'}"><i class="ri-team-line"></i> Customers
                </router-link>
            </li>
            <!-- <li :class="[currentRouteName == 'viewProducts' ? 'active': '']">
                <router-link :to="{ name: 'viewProducts'}"><i class="fas fa-dice-d6"></i> Products</router-link>
            </li> -->
            <!--<li :class="[currentRouteName == 'viewTasks'|| currentRouteName == 'taskDetails' || currentRouteName == 'addTask' || currentRouteName == 'taskEdit' || currentRouteName == 'taskView' ? 'active': '']">
                <router-link :to="{ name: 'viewTasks'}"><i class="ri-list-unordered"></i> Tasks</router-link>
            </li>-->
            <li :class="[currentRouteName == 'reminders' ? 'active': '']">
                <router-link :to="{ name: 'reminders'}"><i class="ri-list-unordered"></i> Reminders</router-link>
            </li>
            <li :class="[currentRouteName == 'tasks' ? 'active': '']">
                <router-link :to="{ name: 'tasks'}"><i class="ri-list-unordered"></i> Order Tasks</router-link>
            </li>
            <!--                <li>-->
            <!--                    <a href="#"><i class="fa fa-suitcase" aria-hidden="true"></i> Vendors</a>-->
            <!--                </li>-->
            <!--                <li>-->
            <!--                    <a href="#"><i class="fas fa-file-alt"></i> Tasks</a>-->
            <!--                </li>-->
            <li>
                <a href="#settingsSubmenu" data-toggle="collapse"
                   :aria-expanded="currentRouteName == 'viewUsers' || currentRouteName == 'userRoles' || currentRouteName == 'viewBagList' ||
                   currentRouteName == 'quotaionStatus' || currentRouteName == 'salesRep' ||currentRouteName == 'viewTasksPriority' ||currentRouteName == 'globalSetting'"
                   class="dropdown-toggle"><i class="ri-settings-3-line"></i> <span>Settings</span></a>
                <ul class="collapse list-unstyled" id="settingsSubmenu"
                    :class="{show: currentRouteName == 'viewUsers' || currentRouteName == 'userRoles' || currentRouteName == 'viewBagList' ||
                   currentRouteName == 'quotaionStatus' || currentRouteName == 'salesRep' ||currentRouteName == 'viewTasksPriority' ||currentRouteName == 'globalSetting'
                 ||currentRouteName == 'notification_settings' ||currentRouteName == 'defaultSetting' ||currentRouteName == 'labels'}">

                    <li v-if="userType == 1 || roleName == 'Admin'">
                        <router-link :to="{ name: 'viewUsers'}"> Users</router-link>

                    </li>
                    <li v-if="userType == 1 || roleName == 'Admin'">
                        <router-link :to="{ name: 'userRoles'}"> Roles
                        </router-link>

                    </li>
                    <li>
                        <router-link :to="{ name: 'viewBagList'}"> Vendor Bags
                        </router-link>
                    </li>
                    <li>
                        <router-link :to="{ name: 'quotaionStatus'}"> Quotations
                            Status
                        </router-link>

                    </li>

                    <li>
                        <router-link :to="{ name: 'salesRep'}"> Sales Rep
                        </router-link>

                    </li>
                    <li>
                        <router-link :to="{ name: 'viewTasksPriority'}"> Task
                            Priority
                        </router-link>
                    </li>
                    <li v-if="userType == 1 || roleName == 'Admin'">
                        <router-link :to="{ name: 'taskWorkflows'}">
                            Task  Workflows
                        </router-link>
                    </li>
                    <!--<li>
                        <router-link :to="{ name: 'defaultSetting'}"> Default Settings
                        </router-link>
                    </li>-->
                    <li>
                        <router-link :to="{ name: 'globalSetting'}"> Global Settings
                        </router-link>
                    </li>
                    <li>
                        <router-link :to="{ name: 'notification_settings'}"> Notification Settings
                        </router-link>
                    </li>
                    <li>
                        <router-link :to="{ name: 'labels'}"> Labels Settings
                        </router-link>
                    </li>
                </ul>
            </li>

            <li v-if="(authUser != null && authUser.user_type == 1) || hasRole('Admin') || hasPerm('view-all-sales-order-report')">
                <a href="#reportsSubmenu" data-toggle="collapse"
                   :aria-expanded="currentRouteName == 'reportsSO' || currentRouteName == 'reportsPO'"
                   class="dropdown-toggle"><i class="ri-settings-3-line"></i> <span>Reports</span></a>
                <ul class="collapse list-unstyled" id="reportsSubmenu"
                    :class="{show: currentRouteName == 'reportsSO' || currentRouteName == 'reportsPO'}">

                    <li v-if="(authUser != null && authUser.user_type == 1) || hasRole('Admin') || hasPerm('view-all-sales-order-report')">
                        <router-link :to="{ name: 'reportsSO'}"> SO / PO Order Reports</router-link>

                    </li>
                    <!-- <li v-if="userType == 1 || roleName == 'Admin'">
                        <router-link :to="{ name: 'reportsPO'}"> Purchase Order Reports
                        </router-link>

                    </li> -->

                </ul>
            </li>
            <li :class="[currentRouteName == 'reminders' ? 'active': '']">
                <router-link :to="{ name: 'viewWarehouse'}"><i class="ri-list-unordered"></i>Warehouse</router-link>
            </li>
            
        </ul>


    </nav>
    <!-- SIDEBAR -->

    <!-- /SIDEBAR -->
</template>

<script>
import { mapState, mapActions, mapGetters  } from 'vuex';
import axios from "axios";
import {EventBus} from "../event-bus";
export default {
    name: "LeftPanel",
    created() {
        this.getMenuItems();
        this.getPoMenuItems();
    },
    // computed: {
    //     currentRouteName() {
    //         return this.$route.name;
    //     }
    // },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setCustomers',
            'setCustomerLoading',
            'setPurchaseOrderMenuItems',
            'setSalesOrderMenuItems',
            'setNewOrder',
            'setOrdersShowFilters',
            'setOrdersFilterData',
            'setPurchaseOrdersShowFilters',
            'setPurchaseOrdersFilterData'
        ]),
        forceRefresh(routeName) {
            if(routeName == 'quotations') {
                EventBus.$emit('resetQuoteFilter');
            }
            else if(routeName == 'viewVendors') {
                EventBus.$emit('resetVendorFilter');
            }
        },
        logout() {
            this.$router.push({name: 'login'});
        },
        goToOrderList(statusId){
            let filterData = {
                search_filter: null,
                sale_user_id: null,
                search_customer_id: null,
                search_added_user_id: null,
                search_by_date: null,
                status_search: null,
                date_range: null
            };

            this.setOrdersFilterData(filterData);
            this.setOrdersShowFilters(false);

            if(this.$route.name == 'orders') {
                this.$root.$emit('changeSOStatusFilter', statusId);
            } else {
                if(statusId) {
                    localStorage.setItem('soFilterStatus', statusId);
                }
                this.$router.push({name: 'orders'});
            }
        },
        goToPurchaseOrderList(statusId){
            let filterData = {
                purchase_search: null,
                search_saleuser_id: null,
                search_vendor_id: null,
                search_added_user_id: null,
                search_by_date: null,
                search_status_Id: null,
                date_range: null
            };

            this.setPurchaseOrdersFilterData(filterData);
            this.setPurchaseOrdersShowFilters(false);
            if(this.$route.name == 'purchaseOrders') {
                this.$root.$emit('changePOStatusFilter', statusId);
            } else {
                if(statusId) {
                    localStorage.setItem('poFilterStatus', statusId);
                }
                this.$router.push({name: 'purchaseOrders'});
            }
        },
        getMenuItems() {
            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('orders.menuItems'), {
                // params: this.filterForm,
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errors){
                        self.setCommonErrors(data.errors);
                    } else if(data.errorMessage){
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        self.setSalesOrderMenuItems(data.data);
                        //console.log("Sales order Menu Items",data.data);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setCustomerLoading(false);

                });
        },
        getPoMenuItems() {
            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('po.menuItems'), {
                //params: this.filterForm,
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errors){
                        self.setCommonErrors(data.errors);
                    } else if(data.errorMessage){
                        self.setErrorMessage(data.errorMessage);
                    } else {

                        //this.vendorData = data.data;
                        self.setPurchaseOrderMenuItems(data.data);
                        //console.log("Sales order Menu Items",data.data);
                        // this.current_page = data.data.vendors.current_page;
                        // this.per_page = data.data.vendors.per_page;
                        // this.total = data.data.vendors.total;
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setCustomerLoading(false);

                });
        },
        goToCreateSO() {
            this.setNewOrder({
                id: null,
                is_draft: 0,
                is_stocking: 0,
                stocking_terms: null,
                warehouses: [],
                customerWarehouses: [],
                billTo: [],
                customer_id: null,
                sales_rep_id: null,
                order_number: null,
                order_date: null,
                customer_terms: null,
                customer_po: null,
                eta: null,
                fob: null,
                notes: null,
                customer_notes: null,
                quotations: [],
                customer: {
                    quotations_after_sent_to_customer: []
                },
                products: [],
                selectedProducts: [],
            });
            this.$router.push({name: 'selectCustomer'});
        },
    },
    computed: {
        ...mapState([
            'userState',
        ]),
        ...mapGetters([
            'salesOrderMenuItems',
            'purchaseOrderMenuItems',
            'getAuthUser',
            'getAuthUserRoleName',
            'getAuthUserPermissions'
        ]),
        currentRouteName() {
            return this.$route.name;
        },
        authUser(){
            return this.getAuthUser;
        },
        userType() {
            return this.getAuthUser ? this.getAuthUser.user_type : null;
        },
        roleName() {
            return this.getAuthUserRoleName;
        },
        permissions() {
            return this.getAuthUserPermissions;
        },
    }
}
</script>

<style scoped>

</style>
